var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"document-downloads-link"},[_c('h2',[_vm._v(_vm._s(_vm.toLocal("downloads.check_leaf")))]),_c('p',[_vm._v(_vm._s(_vm.toLocal("downloads.choose_language_hint")))]),_c('router-link',{attrs:{"to":`/${_vm.$store.state.lang}/downloads`}},[_vm._v(" "+_vm._s(_vm.toLocal("downloads.choose_documents"))+" → ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }